import { DetailFieldGrid, type DetailFieldGridProps } from './DetailFieldGrid';

interface DetailSubsectionProps extends DetailFieldGridProps {
    label: string;
    /** A top border/spacing before this subsection - every one but the first. */
    divider: boolean;
}

// A labelled subsection within a card (Account's Classification / Dental
// Monitoring / Billing / Manufacturer / Equipment). The label reuses the
// same small-caps treatment as the practice header's meta labels (see
// PracticeMetaCell) rather than inventing a new heading style - it needs to
// read as clearly subordinate to the card's own bold title.
export function DetailSubsection({ label, divider, ...gridProps }: DetailSubsectionProps) {
    const isCompact = gridProps.density === 'compact';
    const gapClass = isCompact ? 'gap-1.5' : 'gap-3';
    // Compact only: the parent card body's own gap (see DetailGroupCard's
    // p-3.5/gap-2.5) already puts space before this subsection - adding pt-3
    // on top of that gap doubled up the visual break for no benefit, so the
    // border alone marks it here. Comfortable keeps the original padded
    // divider (unused today, but left intentionally in case it's ever
    // dialled back up).
    const dividerClass = divider
        ? isCompact
            ? 'border-t border-gray-100'
            : 'pt-4 border-t border-gray-100'
        : '';

    return (
        <div className={`flex flex-col ${gapClass} ${dividerClass}`}>
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-[0.04em]">
                {label}
            </span>
            <DetailFieldGrid {...gridProps} />
        </div>
    );
}
